import React, {useState, useEffect, useRef, useContext} from 'react';
import { Container, Card, CardBody, Form, FormGroup, Label, Input, Button, Alert, ButtonGroup } from 'reactstrap';
import axios from 'axios';
import AsyncSelect from 'react-select/async';
import UygunsuzlukModal from '../../pages/Saha/Forms/UygunsuzlukModal';
import SahaFormContext from "../Contexts/Management/SahaFormContext";
import BetterStandsDataModal from "../../pages/Saha/Forms/BetterStandsDataModal";
import { useTranslation } from "react-i18next";

const DynamicForm = ({ formId, standId, selectedData, activeFairId }) => {
  const { t } = useTranslation("formlar");
    const [formData, setFormData] = useState(null);
    const [formResponses, setFormResponses] = useState({});
    const [mainQuestionResponse, setMainQuestionResponse] = useState(0);
    const [file, setFile] = useState(null);
    const [selectedStand, setSelectedStand] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [notes, setNotes] = useState('');
    const fileInputRef = useRef(null);
    const [uygunsuzlukModalOpen, setUygunsuzlukModalOpen] = useState(false);
    const [betterStandsDataModalOpen, setBetterStandsDataModalOpen] = useState(false);
    const [currentUygunsuzluk, setCurrentUygunsuzluk] = useState(null);
    const [formSaved, setFormSaved] = useState(false);
    const [formSahaId, setFormSahaId] = useState(null);
    const [activeFormId, setActiveFormId] = useState(null);
    const { checkOrSave, updateSahaForm, getFormValues, saveFormValue, getFormPhotos, uploadPhoto } = useContext(SahaFormContext);

    const initializeFormResponses = (dataset) => {
        const initialResponses = {};
        dataset.forEach(category => {
            initialResponses[category.id] = {};
            category.subs.forEach(sub => {
                initialResponses[category.id][sub.id] = 3;
            });
        });
        setFormResponses(initialResponses);
    };

    useEffect(() => {
        const denetmenId = localStorage.getItem('userId');

        async function loadForm() {
            try {
                const response = await axios.post('https://fds.sakagrup.com/Saha/generateDenetim/',
                    { form_type_id: formId },
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                if (response.data && response.data.dataset) {
                    setFormData(response.data);
                    initializeFormResponses(response.data.dataset);

                    const firmaId = selectedData?.firmaId || 0;
                    checkOrSave(standId, 1, formId, firmaId, activeFairId, denetmenId).then(res => {
                        const checkedFormId = res.id;
                        setMainQuestionResponse(res.mainQuestionAnswer || 0);
                        console.log("Form kaydı oluşturuldu/bulundu:", res);
                        setActiveFormId(checkedFormId);
                    }).catch(err => {
                        console.error('checkOrSave hatası:', err);
                        setError(t("dynamicFormIndex.formBaslatilamadiLutfenBaglantiniziKontrol"));
                    });
                } else {
                    throw new Error(t("dynamicFormIndex.sunucudanGecersizVeriYapisiAlindi"));
                }
            } catch (error) {
                console.error('Form verisi yüklenirken hata:', error);
                setError(t("dynamicFormIndex.formYuklenemediLutfenDahaSonra"));
            } finally {
                setLoading(false);
            }
        }

        if (formId && standId && activeFairId && denetmenId) {
            loadForm();
        }

        // Stand seçiliyse ayarla (sync — sadece prop'tan hesaplanıyor, effect gerekmez)
        if (standId && selectedData) {
            async function setStand() {
                setSelectedStand({
                    value: standId,
                    label: selectedData.stand_name || selectedData.name || t("dynamicFormIndex.stand", { standId })
                });
            }
            setStand();
        }
    }, [formId, standId, selectedData, activeFairId]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(activeFormId) {
                getFormValues(activeFormId).then(formContentValues => {
                    if(formContentValues && formContentValues.length > 0){
                        const updatedResponses = {...formResponses};
                        formContentValues.forEach(item => {
                            if (!updatedResponses[item.categoryId]) {
                                updatedResponses[item.categoryId] = {};
                            }
                            updatedResponses[item.categoryId][item.subId] = item.answerValue;
                        });
                        setFormResponses(updatedResponses);
                        console.log("Updated form responses:", updatedResponses);
                    }
                });

        }
    }, [activeFormId]);


    const handleInputChange = (categoryId, subId, value, subName) => {
        let formLevelId = 2;
        if(value === 1){
            formLevelId = 4;
        }else if(value === 2){
            formLevelId = 3;
        }
        saveFormValue(activeFormId, categoryId, subId, value, formLevelId).then((res) => {
            console.log("Form value saved successfully:", res);
        }).catch(err => {
            console.error('Error saving form value:', err);
        });
        setFormResponses(prev => ({
            ...prev,
            [categoryId]: {
                ...prev[categoryId],
                [subId]: value
            }
        }));

        if(formId === 14){
            setCurrentUygunsuzluk({ categoryId, subId, konuName: subName });
            setBetterStandsDataModalOpen(true);
        }else{
            if (value === 2) {
                setCurrentUygunsuzluk({ categoryId, subId, konuName: subName });
                setUygunsuzlukModalOpen(true);
            }
        }
    };

    const handleMainQuestionChange = (value) => {
        if(activeFormId){
            const sampleSahaForm = {};
            sampleSahaForm.mainQuestionAnswer = value;
            updateSahaForm(activeFormId,sampleSahaForm).then((res) => {
                console.log("Saha form updated successfully:", res);
            }).catch(err => {
                console.error('Error updating main question:', err);
            })
        }
        setMainQuestionResponse(value);
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleCameraClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const loadStandOptions = async (inputValue) => {
        if (standId && selectedData) {
            // If standId and selectedData are provided, return only that option
            return [{
                value: standId,
                label: selectedData.stand_name || selectedData.name || t("dynamicFormIndex.stand", { standId })
            }];
        }

        try {
            const response = await axios.get('YOUR_STAND_API_ENDPOINT', {
                params: { search: inputValue }
            });
            return response.data.map(stand => ({
                value: stand.id,
                label: stand.name
            }));
        } catch (error) {
            console.error('Error fetching stand options:', error);
            return [];
        }
    };

    const handleStandChange = (selectedOption) => {
        setSelectedStand(selectedOption);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!activeFormId) {
            alert(t("dynamicFormIndex.formIdBulunamadiLutfenFormu"));
            return;
        }

        console.log('Form Gönderiliyor - activeFormId:', activeFormId);
        console.log('Main Question Response:', mainQuestionResponse);
        console.log('Notlar:', notes);
        console.log('Fotoğraf var mı:', !!file);

        try {
            // Step 1: Form bilgilerini güncelle (isDone: true, completedAt: now)
            // ⚠️ Guide note: mainQuestionAnswer omit etiyoruz - partial update için önerilir
            const updateData = {
                isDone: true,
                completedAt: new Date().toISOString()
            };

            console.log('Adım 1: Form güncelleniyor...');
            console.log('Update payload:', JSON.stringify(updateData));
            const updateResponse = await updateSahaForm(activeFormId, updateData);
            console.log('✅ Form başarıyla güncellendi:', updateResponse);

            // Step 2: Fotoğraf varsa yükle
            if (file) {
                console.log('Adım 2: Fotoğraf yükleniyor...');
                try {
                    // Fotoğraf yükleme - POST /sahaform/{formId}/photo?fuarId={fuarId}
                    const uploadResult = await uploadPhoto(activeFormId, activeFairId, file);
                    console.log('✅ Fotoğraf başarıyla yüklendi:', uploadResult);
                } catch (photoError) {
                    console.error('⚠️ Fotoğraf yükleme hatası:', photoError);
                    // Fotoğraf yüklenemese de formu gönderiş başarılı sayabiliriz
                }
            }

            alert(t("dynamicFormIndex.formBasariylaGonderildi"));
            setFormSaved(true);
            // Form sıfırlama vb. işlemler

        } catch (error) {
            console.error('❌ Form gönderme hatası:', error);
            alert(t("dynamicFormIndex.formGonderilemedi") + (error.response?.data?.message || error.message));
        }
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <Alert color="danger">{error}</Alert>;
    if (!formData) return <Alert color="warning">No form data available.</Alert>;

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                {/* Stand Selection */}
                <Card className="mb-3">
                    <CardBody>
                        <FormGroup>
                            <Label for="standSelect">{t("dynamicFormIndex.stand2")}</Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={loadStandOptions}
                                onChange={handleStandChange}
                                value={selectedStand}
                                placeholder="Select a stand..."
                                isDisabled={!!standId && !!selectedData}
                            />
                        </FormGroup>
                    </CardBody>
                </Card>

                {/* Main Question */}
                <Card className="mb-3">
                    <CardBody>
                        <FormGroup tag="fieldset">
                            <div className="d-flex justify-content-between align-items-center">
                                <legend className="mb-0">{formData.main_question}</legend>
                                {formId === 14 ? (
                                    <ButtonGroup>
                                        <Button
                                            color={mainQuestionResponse === 1 ? "success" : "outline-success"}
                                            onClick={() => handleMainQuestionChange(1)}
                                        >
                                            {t("dynamicFormIndex.moduler")}
                                        </Button>
                                        <Button
                                            color={mainQuestionResponse === 2 ? "warning" : "outline-warning"}
                                            onClick={() => handleMainQuestionChange(2)}
                                        >
                                            {t("dynamicFormIndex.ahsap")}
                                        </Button>
                                        <Button
                                            color={mainQuestionResponse === 3 ? "primary" : "outline-primary"}
                                            onClick={() => handleMainQuestionChange(3)}
                                        >
                                            {t("dynamicFormIndex.paket")}
                                        </Button>
                                    </ButtonGroup>
                                ) : (
                                    <ButtonGroup>
                                            <Button
                                            color={mainQuestionResponse === 1 ? "success" : "outline-success"}
                                        onClick={() => handleMainQuestionChange(1)}
                                    >
                                        {t("dynamicFormIndex.var")}
                                    </Button>
                                    <Button
                                        color={mainQuestionResponse === 2 ? "warning" : "outline-warning"}
                                        onClick={() => handleMainQuestionChange(2)}
                                    >
                                        {t("dynamicFormIndex.yok")}
                                    </Button>
                                </ButtonGroup>
                                )}

                            </div>
                        </FormGroup>
                    </CardBody>
                </Card>

                {/* Rest of the form */}
                {formData.dataset.map(category => (
                    <Card key={category.id} className="mb-3">
                        <CardBody>
                            <h3>{category.name}</h3>
                            {category.subs.map(sub => (
                                <FormGroup key={sub.id}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <Label className="mb-0">{sub.name}</Label>
                                        <ButtonGroup>
                                            {sub.quest_type === "0" ? (
                                                <>
                                                    <Button
                                                        color={formResponses[category.id][sub.id] === 1 ? "secondary" : "outline-secondary"}
                                                        onClick={() => handleInputChange(category.id, sub.id, 1, sub.name)}
                                                    >
                                                        {t("dynamicFormIndex.var")}
                                                    </Button>
                                                    <Button
                                                        color={formResponses[category.id][sub.id] === 2 ? "primary" : "outline-primary"}
                                                        onClick={() => handleInputChange(category.id, sub.id, 2, sub.name)}
                                                    >
                                                        {t("dynamicFormIndex.yok")}
                                                    </Button>
                                                    <Button
                                                        color={formResponses[category.id][sub.id] === 0 ? "success" : "outline-success"}
                                                        onClick={() => handleInputChange(category.id, sub.id, 0, sub.name)}
                                                    >
                                                        {t("dynamicFormIndex.gerekYok")}
                                                    </Button>
                                                </>
                                            ) : (
                                                <>
                                                    <Button
                                                        color={formResponses[category.id][sub.id] === 1 ? "secondary" : "outline-secondary"}
                                                        onClick={() => handleInputChange(category.id, sub.id, 1, sub.name)}
                                                    >
                                                        {t("dynamicFormIndex.uygun")}
                                                    </Button>
                                                    <Button
                                                        color={formResponses[category.id][sub.id] === 2 ? "primary" : "outline-primary"}
                                                        onClick={() => handleInputChange(category.id, sub.id, 2, sub.name)}
                                                    >
                                                        {t("dynamicFormIndex.uygunDegil")}
                                                    </Button>
                                                    <Button
                                                        color={formResponses[category.id][sub.id] === 0 ? "success" : "outline-success"}
                                                        onClick={() => handleInputChange(category.id, sub.id, 0, sub.name)}
                                                    >
                                                        {formId === 14 ? t("dynamicFormIndex.yok"):t("dynamicFormIndex.gerekYok")}
                                                    </Button>
                                                </>
                                            )}
                                        </ButtonGroup>
                                    </div>
                                </FormGroup>
                            ))}
                        </CardBody>
                    </Card>
                ))}

                {/* Notes */}
                <Card className="mb-3">
                    <CardBody>
                        <FormGroup>
                            <Label for="saha_form_notes">{t("dynamicFormIndex.notlar")}</Label>
                            <Input
                                type="textarea"
                                name="saha_form_notes"
                                id="saha_form_notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                rows="4"
                            />
                        </FormGroup>
                    </CardBody>
                </Card>

                {/* File Upload */}
                <Card className="mb-3" >
                    <CardBody>
                        <FormGroup>
                            <Label for="fileUpload">{t("dynamicFormIndex.fotografEkle")}</Label>
                            <Input
                                type="file"
                                name="file"
                                id="fileUpload"
                                onChange={handleFileChange}
                                innerRef={fileInputRef}
                            />
                            <Button type="button" color="secondary" onClick={handleCameraClick} className="mt-2">
                                {t("dynamicFormIndex.kamera")}
                            </Button>
                        </FormGroup>
                    </CardBody>
                </Card>

                {/* Submit Button */}
                <Button type="submit" color="primary"  className="w-100">{t("dynamicFormIndex.formuGonder")}</Button>
                
                <UygunsuzlukModal
                    isOpen={uygunsuzlukModalOpen}
                    toggle={() => setUygunsuzlukModalOpen(false)}
                    formId={formId}
                    standId={standId}
                    selectedData={selectedData}
                    categoryId={currentUygunsuzluk?.categoryId}
                    subId={currentUygunsuzluk?.subId}
                    konuName={currentUygunsuzluk?.konuName}
                />

                <BetterStandsDataModal
                    isOpen={betterStandsDataModalOpen}
                    toggle={() => setBetterStandsDataModalOpen(false)}
                    formId={formId}
                    standId={standId}
                    selectedData={selectedData}
                    categoryId={currentUygunsuzluk?.categoryId}
                    subId={currentUygunsuzluk?.subId}
                    konuName={currentUygunsuzluk?.konuName}
                />
            </Form>
        </Container>
    );
};

export default DynamicForm;
